"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.findStartIndex = void 0;
const Toolbar_1 = require("../..");
const findStartIndex = (array) => {
    let startIndex = 0;
    for (let i = 0; i < array.length - 1; i++) {
        if (array[i].type === Toolbar_1.TOOLBAR_ITEM_TYPE.customControl) {
            startIndex = i;
        }
    }
    return startIndex === 0 ? 0 : startIndex + 1;
};
exports.findStartIndex = findStartIndex;
//# sourceMappingURL=findStartIndex.js.map